package br.com.heyagenda.domain.util

import kotlin.js.Date

actual fun getPlatformCurrentDateTime(): CurrentDateTime {
    val d = Date()
    val timeZone = try {
        js("Intl.DateTimeFormat().resolvedOptions().timeZone") as? String ?: "America/Sao_Paulo"
    } catch (_: Throwable) {
        "America/Sao_Paulo"
    }
    // getTimezoneOffset() returns minutes difference between UTC and local time (e.g., UTC-3 is +180)
    // Invert sign so UTC-3 is -180
    val offset = -d.getTimezoneOffset()

    return CurrentDateTime(
        year = d.getFullYear(),
        monthNumber = d.getMonth() + 1,
        dayOfMonth = d.getDate(),
        hour = d.getHours(),
        minute = d.getMinutes(),
        timeZoneId = timeZone,
        utcOffsetMinutes = offset
    )
}
